//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.1.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum ChatService {
    GoogleCloudService = 0,
    GoogleGenerativeAiService = 1,
    L3LocalAi = 2,
    AnthropicClaude = 3,
}

export enum MultiModalLlmService {
    GoogleCloudService = 0,
    L3LocalAi = 1,
    AnthropicClaude = 2,
}

export enum TtsServiceNames {
    GoogleGenAi = 0,
    GoogleTextToSpeech = 1,
    L3LocalAi = 2,
}

export enum TranscriptionServiceNames {
    GoogleSpeech = 0,
    IntegratedWhisper = 1,
    L3LocalAi = 2,
}

export enum ImageGenerationService {
    GoogleImageGeneration = 0,
    L3LocalAi = 1,
}

export enum VideoGenerationService {
    GoogleVeo = 0,
    GoogleOmni = 1,
    L3LocalAi = 2,
}

export interface CustomizationVm {
    customer: string | null;
    appName: string | null;
    enableReleaseProzess: boolean;
    enablePreRelease: boolean;
    enableTrainingEvents: boolean;
    enableOldContentManager: boolean;
    enableReplaceOldCourses: boolean;
    enableAi: boolean;
    aiChatCreditsLimitReached: boolean;
    aiMediaCreditsLimitReached: boolean;
    aiCreditsLimitPerMonth: number;
    aiCreditsLimitForCurrentMonth: number;
    enableGoogleApi: boolean;
    googleApiKey: string | null;
    enableGoogleCloud: boolean;
    enableAnthropicApi: boolean;
    anthropicApiKey: string | null;
    chatService: ChatService;
    chatModel: string | null;
    multiModalLlmService: MultiModalLlmService;
    multiModalLlmModel: string | null;
    standardTtsService: TtsServiceNames;
    standardTtsModel: string | null;
    podcastTtsService: TtsServiceNames;
    podcastTtsModel: string | null;
    transcriptionService: TranscriptionServiceNames;
    transcriptionModel: string | null;
    imageGenerationService: ImageGenerationService;
    imageGenerationModel: string | null;
    videoGenerationService: VideoGenerationService;
    videoGenerationModel: string | null;
}